import { setActiveAccount, clearActiveAccount } from "../actions/accountAction";
import { authClearUser } from "../actions/authAction";

function accountReducer(state = { activeAccount: null }, action) {
  switch (action.type) {
    case setActiveAccount.type:
      return { ...state, activeAccount: action.payload };
    case clearActiveAccount.type:
    case authClearUser.type:
      return { ...state, activeAccount: null };
    default:
      return state;
  }
}

export default accountReducer;
